import { render, staticRenderFns } from "./AussieTimesRenewal.vue?vue&type=template&id=704aae0a"
import script from "./AussieTimesRenewal.vue?vue&type=script&lang=ts"
export * from "./AussieTimesRenewal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports